import React from 'react';
import logo from '../images/logo.png';
import s from './Logo.module.css';
import { Link } from 'react-router-dom';

export default function Logo() {
  return (
    <Link to="/" className={s.logo}>
      <img src={logo} alt={'logo'} />
    </Link>
  );
}
